module.exports = __webpack_public_path__ + "img/DSC_0003-copy-02.ee34b63.png";